'use strict';

// Public provider identifiers; these already ship in the web/native client.
const googleClientId = '822974377574-t0tqqeg9vfks787f4c5in1qfq6l5fgdo.apps.googleusercontent.com';
const appleClientId = 'ai.gab.web.signin';
const handoffKey = 'gab:public-auth:handoff';
const handoffMaxAge = 2 * 60 * 1000;
function validSession(data) {
  return !!(data && typeof data.tokens?.access === 'string' && data.tokens.access
    && typeof data.tokens.refresh === 'string' && data.tokens.refresh
    && typeof data.user?.id === 'string' && data.user.id
    && Number.isFinite(Date.parse(data.tokens.expiresAt)) && Date.parse(data.tokens.expiresAt) > Date.now());
}
function safeDestination(value) {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//')) return '/app';
  try {
    const url = new URL(value, 'https://gab.ai');
    if (url.origin === 'https://gab.ai' && (url.pathname === '/app'
      || url.pathname === '/payment-successful' && url.searchParams.get('checkoutContext'))) return url.pathname + url.search;
  } catch { /* Only the application's established sign-in destinations are valid. */ }
  return '/app';
}
function writeHandoff(storage, data, destination = '/app') {
  if (!validSession(data)) throw Error('Authentication failed. Please try again.');
  storage.setItem(handoffKey, JSON.stringify({ data, destination: safeDestination(destination), createdAt: Date.now() }));
  // Fail explicitly when private browsing/storage restrictions prevent transfer.
  if (!storage.getItem(handoffKey)) throw Error('Browser storage is unavailable. Please allow storage and try again.');
}
function consumeHandoff(storage) {
  const raw = storage.getItem(handoffKey);
  if (!raw) return null;
  storage.removeItem(handoffKey);
  const record = JSON.parse(raw);
  const age = Date.now() - record?.createdAt;
  if (!Number.isFinite(age) || age < 0 || age > handoffMaxAge || !validSession(record?.data)) throw Error('Sign-in expired. Please log in again.');
  return { data: record.data, destination: safeDestination(record.destination) };
}
module.exports = { googleClientId, appleClientId, handoffKey, validSession, safeDestination, writeHandoff, consumeHandoff };
